<input
  type="text"
  pInputText
  inputmode="numeric"
  class="text-center w-full"
  [formControl]="control()"
  (blur)="formatTime($event)"
  (keypress)="onKeyPress($event)"
/>
